import React from 'react';
import ReactPaginate from 'react-paginate';
import './Pagination.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange, 
  totalItems, 
  itemsPerPage,
  showInfo = true 
}) => {
  if (totalPages <= 1) {
    return null; // Don't show pagination if there's only one page or less
  }

  const startItem = (currentPage * itemsPerPage) + 1;
  const endItem = Math.min((currentPage + 1) * itemsPerPage, totalItems);

  return (
    <div className="pagination-container">
      {showInfo && (
        <div className="pagination-info">
          Showing {startItem} to {endItem} of {totalItems} entries
        </div>
      )}
      
      <ReactPaginate
        previousLabel={
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1.5"
            strokeLinecap="round" 
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="10,12 6,8 10,4"></polyline>
          </svg>
        }
        nextLabel={
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="1.5"
            strokeLinecap="round" 
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <polyline points="6,12 10,8 6,4"></polyline>
          </svg>
        }
        breakLabel="..."
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={onPageChange}
        forcePage={currentPage}
        containerClassName="pagination"
        pageClassName="pagination-item"
        pageLinkClassName="pagination-link"
        previousClassName="pagination-item pagination-prev"
        previousLinkClassName="pagination-link"
        nextClassName="pagination-item pagination-next"
        nextLinkClassName="pagination-link"
        breakClassName="pagination-item pagination-break"
        breakLinkClassName="pagination-link"
        activeClassName="pagination-active"
        disabledClassName="pagination-disabled"
      />
    </div>
  );
};

export default Pagination;